export function AppIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="86"
      height="86"
      viewBox="0 0 86 86"
      fill="none"
      className="shrink-0"
    >
      <rect
        x="3"
        y="3"
        width="80"
        height="80"
        rx="20"
        fill="url(#paint0_radial_5683_28907)"
      />
      <rect
        x="1.5"
        y="1.5"
        width="83"
        height="83"
        rx="21.5"
        stroke="white"
        strokeOpacity="0.1"
        strokeWidth="3"
      />
      <path
        d="M57.9984 25.3561C59.9589 24.5431 61.5285 22.9925 62.355 21.0129C62.5981 20.4319 63.3935 20.4319 63.6366 21.0129C64.464 22.9925 66.0327 24.5422 67.9931 25.3561C68.5399 25.5826 68.5399 26.3865 67.9931 26.613C66.0327 27.426 64.4631 28.9766 63.6366 30.9562C63.3935 31.5372 62.5981 31.5372 62.355 30.9562C61.5275 28.9766 59.9589 27.4269 57.9984 26.613C57.4517 26.3865 57.4517 25.5826 57.9984 25.3561Z"
        fill="#48E6B9"
      />
      <path
        d="M17.044 43.1434H33.1508C40.7217 43.1434 47.9577 47.3184 51.2702 52.6981C53.9844 48.0405 56.3967 42.3066 57.5274 34.7998H67.3661C65.6316 45.5883 62.3823 53.4375 55.6201 62.2072H44.3059C41.9713 57.1981 36.3105 52.261 28.532 52.2901C24.5352 52.3047 14.9216 52.2901 14.9216 52.2901L17.044 43.1434Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_5683_28907"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(83 -6.03702) rotate(128.067) scale(129.747)"
        >
          <stop stopColor="#353A4C" />
          <stop offset="1" stopColor="#02061D" />
        </radialGradient>
      </defs>
    </svg>
  )
}
